export { default } from './clamp';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/clamp/index.js
// module id = 188
// module chunks = 22